export default __webpack_public_path__ + "static/media/README.876557b8.md";